<template>
	<div>
		<v-navigation-drawer
			v-model="drawer"
			fixed
			bottom
			temporary
			class="background-transition"
		>
			<router-link to="/" flat class="elevation-0 ma-0">
				<v-toolbar flat light class="py-2 background--none">
					<v-list class="full-width">
						<v-list-tile>
							<v-list-tile-avatar class="mr-1">
								<img
									src="https://image.flaticon.com/icons/png/512/61/61173.png"
									alt="author"
								/>
							</v-list-tile-avatar>
							<v-list-tile-content>
								<v-list-tile-title
									class="subheading white--text"
								>
									<b>{{ userName }}</b>
								</v-list-tile-title>
								<v-list-tile-sub-title class="white--text">
									{{ userStatus }}
								</v-list-tile-sub-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list>
				</v-toolbar>
			</router-link>
			<v-divider></v-divider>
			<v-list class="pt-3">
				<router-link
					:to="item.url"
					v-for="(item, index) in allowedPanelEl"
					:key="index"
					class="no-text-dec list__tile--link mb-2"
				>
					<v-list class="pa-0 background--none" @click="signOut">
						<v-list-tile>
							<v-list-tile-action>
								<v-icon class="white--text">
									{{ item.icon }}
								</v-icon>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title
									:class="
										RUMMY_ROUTES.includes(item.url)
											? 'red--text'
											: 'white--text'
									"
								>
									<div
										v-if="
											notifDotPanelList.includes(
												item.routeName
											)
										"
										class="notif-dot panel-item"
									/>
									<span
										:class="
											notifDotPanelList.includes(
												item.routeName
											) && 'ml-1'
										"
										>{{
											item.name === "My Associates"
												? isJeet11Partner ||
												  isJeet11Promoter
													? "My Users"
													: item.name
												: item.name
										}}</span
									>
								</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list>
				</router-link>

				<!-- <v-divider class="mt-5 mb-1"/> -->

				<v-list-tile class="py-2" @click="signOut">
					<v-list-tile-action>
						<v-icon class="white--text">power_settings_new</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title class="white--text"
							>Log Out</v-list-tile-title
						>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>
		</v-navigation-drawer>
		<v-toolbar color="white elevation-1" light fixed app>
			<div v-if="showNotifDot" class="notif-dot menu-icon" />
			<v-toolbar-title
				><img
					v-if="pageHeaderLogo"
					:src="pageHeaderLogo"
					alt="logo"
					class="header-logo"
				/>
				<div v-else>
					{{
						pageTitle === "My Associates"
							? isJeet11Partner || isJeet11Promoter
								? "My Users"
								: pageTitle
							: pageTitle
					}}
				</div>
			</v-toolbar-title>
			<v-spacer></v-spacer>

			<v-menu offset-y>
				<template v-slot:activator="{ on }">
					<v-avatar
						color="#A3AED0"
						size="40px"
						v-on="on"
						style="cursor: pointer;"
					>
						<img
							v-if="agencyData && agencyData.profilePic"
							:src="agencyData.profilePic"
							alt="profilepic"
						/>
						<div
							v-else
							class="dflex justify-center align-center font-weight-bold"
						>
							{{ getInitial() }}
						</div>
					</v-avatar>
				</template>

				<v-list class="menu-tile">
					<v-list-tile
						v-for="item in items"
						:key="item.label"
						@click="item.onclick"
					>
						<v-icon :color="item.color">{{ item.icon }}</v-icon>
						<v-list-tile-title
							style="margin-left: 20px;"
							:style="{ color: item.color }"
							>{{ item.label }}
						</v-list-tile-title>
					</v-list-tile>
				</v-list>
			</v-menu>
		</v-toolbar>
		<main>
			<v-content
				style="padding-top: 70px; max-width: 600px; margin: auto"
			>
				<v-container fluid fill-height class="pa-0">
					<v-layout class="full-width">
						<router-view class="full-width"></router-view>
					</v-layout>
				</v-container>
			</v-content>
		</main>
		<v-snackbar bottom right v-model="alert.show">{{
			alert.text
		}}</v-snackbar>
		<v-dialog v-model="retailAlert.length" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Notification</span>
				</v-card-title>
				<div style="display:flex;flex-direction:column;">
					<div
						style="align-self: center;font-size:x-large;"
						class="mb-4"
					>
						{{ retailAlert[0] && retailAlert[0].title }}
					</div>
					<div style="align-self: center;font-size:large;">
						{{ retailAlert[0] && retailAlert[0].body }}
					</div>
				</div>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="error"
						flat
						@click="changeAlertStatus(retailAlert[0].id)"
						>Close</v-btn
					>
				</v-card-actions>
			</v-card></v-dialog
		>
		<v-dialog
			v-model="showAddLocationPopup"
			persistent
			max-width="600px"
			v-if="isJeet11Partner"
		>
			<v-card>
				<v-card-title>
					<span class="headline">Notification</span>
				</v-card-title>
				<div class="text-xs-center" style="font-size:large;">
					{{
						jeet11PartnerDetails.shopStatus === "rejected"
							? "Profile verification rejected, fill details again"
							: "Add Location in Profile Section"
					}}
				</div>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="error"
						flat
						@click="handleAddLocationPopupClose"
						v-if="showCloseAddLocationPopup"
						>Close</v-btn
					>
					<v-btn color="primary" flat @click="goToProfile"
						>Go to Profile</v-btn
					>
				</v-card-actions>
			</v-card></v-dialog
		>
	</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import {
	UPDATE_PAGE_TITLE,
	FETCH_RETAILER_DATA,
	USER_LOG_OUT,
	UPDATE_FIREBASE_TOKEN,
	FETCH_JEET11_PARTNER_WALLET_DETAILS,
	GET_USER_ACTIVE_ALERTS,
	CHANGE_ALERT_STATUS
} from "@/store/action-types";
import {
	PANEL_DATA,
	getNotificationPermission,
	supportsPushNotification
} from "@/utils";
import FCMPush from "../fcmPush";
import EventsManager from "../event-manager";
import {
	RUMMY_ROUTES,
	STATUS,
	startPivotTime,
	endPivotTime
} from "./constants";

export default {
	name: "Home",
	data() {
		return {
			drawer: false,
			RUMMY_ROUTES: RUMMY_ROUTES,
			deviceId: "",
			notifDotPanelList: [],
			showNotifDot: false,
			retailAlert: [],
			showAddLocationPopup: false,
			showCloseAddLocationPopup: false,
			items: [
				{
					label: "Logout",
					icon: "power_settings_new",
					color: "red",
					onclick: this.signOut
				}
			]
		};
	},
	computed: {
		...mapGetters({
			isRetailAdmin: "auth/isRetailAdmin",
			isRetailer: "auth/isRetailer",
			isJeet11Partner: "auth/isJeet11Partner",
			isJeet11Distributor: "auth/isJeet11Distributor",
			isJeet11Executive: "auth/isJeet11Executive",
			isJeet11Captain: "auth/isJeet11Captain",
			isJeet11TSM: "auth/isJeet11TSM",
			isJeet11RBM: "auth/isJeet11RBM",
			isFinanceAdmin: "auth/isFinanceAdmin",
			isJeet11Promoter: "auth/isJeet11Promoter",
			isAgency: "jeet11/isAgency",
			isMojAgency: "jeet11/isMojAgency",
			isNewSchemeRetailer: "jeet11/isNewSchemeRetailer",
			isNewSchemeRetailerCardGames: "jeet11/isNewSchemeRetailerCardGames",
			isInShopType: "jeet11/isInShopType",
			dstrSignatureStatus: "jeet11/dstrSignatureStatus",
			isOnlineUser: "auth/isOnlineUser"
		}),
		...mapState({
			ACCESS_TOKEN: state => state.auth.ACCESS_TOKEN,
			USERID: state => state.auth.USERID,
			USERNAME: state => state.auth.USERNAME,
			userData: state => state.retail.retailerData,
			alert: state => state.common.alert,
			pageTitle: state => state.common.pageTitle,
			pageHeaderLogo: state => state.common.headerLogo,
			jeet11PartnerDetails: state => state.jeet11.jeet11PartnerDetails,
			agencyData: state => state.agency.agencyData,
			creditLimit: state =>
				state.jeet11.jeet11PartnerDetails.creditLimit || 0
		}),
		allowedPanelEl() {
			return PANEL_DATA.filter(el => {
				if (this.isOnlineUser && el.requiresOnlineUserAccess) {
					return true;
				}
				if (el.url === "/profile") {
					return !(
						this.isJeet11Captain &&
						this.isAgency &&
						this.isMojAgency
					);
				}
				if (el.url === "/qrCode") {
					return !(
						this.isJeet11Captain ||
						this.isAgency ||
						this.isJeet11RBM ||
						this.isMojAgency
					);
				}
				if (el.url === "/my-associates" || el.url === "/metrics") {
					return !(
						this.isJeet11Captain ||
						this.isAgency ||
						this.isMojAgency ||
						this.isOnlineUser
					);
				}
				if (el.url === "/notifications") {
					return this.isRetailAdmin || this.isFinanceAdmin;
				}
				if (el.url === "/all-leaderboards") {
					return !(
						this.isRetailAdmin ||
						this.isFinanceAdmin ||
						this.isOnlineUser
					);
				}
				if (el.url === "/task-review-section") {
					return (
						(this.isJeet11Executive && !this.isOnlineUser) ||
						this.isJeet11TSM
					);
				}
				if (el.url === "/week-planning") {
					return this.isJeet11TSM;
				}
				if (el.url === "/location-review") {
					return this.isJeet11RBM;
				}
				if (el.url === "/visit-history") {
					return (
						this.isJeet11RBM ||
						(this.isJeet11Executive && !this.isOnlineUser) ||
						this.isJeet11TSM
					);
				}
				if (el.requiresJEET11CaptainAccess && this.isJeet11Captain) {
					return true;
				} else if (el.requiresRetailAdminAccess && this.isRetailAdmin) {
					return true;
				} else if (
					el.requiresRetailAccess &&
					this.isRetailer &&
					!this.isJeet11Distributor &&
					!this.isJeet11Executive &&
					!this.isJeet11Captain &&
					!this.isJeet11TSM &&
					!this.isJeet11RBM &&
					!this.isJeet11Partner &&
					!this.isJeet11Promoter &&
					!this.isOnlineUser
				) {
					return true;
				} else if (
					el.requiresJEET11DistributorAccessOnly &&
					this.isJeet11Distributor &&
					!this.isOnlineUser
				) {
					return true;
				} else if (
					el.requiresJEET11DistributorAccess &&
					(this.isJeet11Distributor || this.isJeet11Executive) &&
					!this.isOnlineUser
				) {
					return true;
				} else if (
					el.requiresFinanceAdminAccess &&
					this.isFinanceAdmin
				) {
					return true;
				} else if (
					el.requiresAgencyAccess &&
					(this.isAgency || this.isMojAgency)
				) {
					if (this.isMojAgency && this.creditLimit > 0) {
						return true;
					} else if (!this.isMojAgency) {
						return true;
					}
				} else if (
					el.requiresJEET11PartnerAccess &&
					this.isJeet11Partner &&
					!this.isOnlineUser
				) {
					return true;
				} else if (
					el.requiresJEET11PromoterAccess &&
					this.isJeet11Promoter
				) {
					return true;
				} else if (
					el.requiresSomeAccess &&
					(this.isRetailer ||
						this.isRetailAdmin ||
						this.isJeet11Distributor ||
						this.isJeet11Partner ||
						this.isJeet11Captain ||
						this.isJeet11Executive ||
						this.isJeet11Promoter) &&
					!this.isAgency &&
					!this.isMojAgency &&
					!this.isJeet11TSM &&
					!this.isJeet11RBM &&
					!this.isOnlineUser
				) {
					return true;
				} else if (el.requiresJEET11TSMAccess && this.isJeet11TSM) {
					return true;
				} else if (el.requiresJEET11RBMAccess && this.isJeet11RBM) {
					return true;
				} else if (
					el.requiresNewSchemeRetailAccess &&
					this.isNewSchemeRetailer &&
					(this.isJeet11Partner ||
						(this.isJeet11Promoter && this.isInShopType))
				) {
					return true;
				} else if (
					el.requiresNewSchemeDstrAccessFantasy &&
					this.isJeet11Distributor &&
					this.isNewSchemeRetailer
				) {
					return true;
				} else if (
					el.requiresNewSchemeDstrAccessCardGames &&
					this.isJeet11Distributor &&
					this.isNewSchemeRetailerCardGames &&
					!this.isOnlineUser
				) {
					return true;
				}
				return false;
			});
		},
		userName() {
			return (this.userData && this.userData.name) || "";
		},
		userStatus() {
			return (this.userData && this.userData.handle) || "";
		}
	},
	async created() {
		const fpPromise = FingerprintJS.load();
		const fp = await fpPromise;
		const result = await fp.get();
		this.deviceId = result.visitorId;
		if (this.ACCESS_TOKEN === null) {
			this.$router.replace("/");
		} else {
			if (this.isRetailer) {
				this.$store.dispatch(UPDATE_PAGE_TITLE.dispatch, {
					routeName: this.$route.name
				});
				this.$store
					.dispatch(FETCH_RETAILER_DATA.dispatch, {
						userId: this.USERID,
						dataKey: "retailerData"
					})
					.then(() => {
						const createdOnSplit = this.userData.createdOn.split(
							"/"
						);
						const createdOnTime = new Date(
							`${createdOnSplit[1]}/${createdOnSplit[0]}/${createdOnSplit[2]}`
						).getTime();
						const currTime = new Date().getTime();
						this.showCloseAddLocationPopup =
							createdOnTime < startPivotTime &&
							currTime < endPivotTime;
					})
					.catch(() => {});
			}
		}
	},
	mounted() {
		this.registerServiceWorker();
		this.showNotifRedDot();
		// this.getUserActiveAlerts();
		if (this.ACCESS_TOKEN !== null) {
			this.fetchJeet11WalletDetails();
			setTimeout(() => {
				if (window.ReactNativeWebView) {
					window.ReactNativeWebView.postMessage(
						JSON.stringify({
							accessToken: this.ACCESS_TOKEN
						})
					);
				}
			}, 200);
			this.getNotificationPermissionFn();
		}
		if (!window.ReactNativeWebView) {
			setTimeout(() => {
				if (navigator.geolocation) {
					let location = "";
					navigator.geolocation.getCurrentPosition(
						position => {
							const { latitude, longitude } = position.coords;
							location = `${latitude}|${longitude}`;
							EventsManager.sendEvent({
								name: "RETAIL_APP_OPEN",
								properties: {
									jsVersion: "web",
									location,
									uniqueId: this.deviceId
								}
							});
						},
						error => {
							const { code, message } = error;
							location = `${code}|${message}`;
							EventsManager.sendEvent({
								name: "RETAIL_APP_OPEN",
								properties: {
									jsVersion: "web",
									location,
									uniqueId: this.deviceId
								}
							});
						}
					);
				}
			}, 1000);
		}
	},
	methods: {
		getInitial() {
			const firstLetter = this.jeet11PartnerDetails.retailerName.slice(0,1).toUpperCase();
			return firstLetter;
		},
		fetchJeet11WalletDetails() {
			this.$store
				.dispatch(FETCH_JEET11_PARTNER_WALLET_DETAILS.dispatch, {
					isSchemeRequired: true,
					isCardGame: 0
				})
				.then(() => {
					// this.showAddLocationPopup =
					// 	this.jeet11PartnerDetails.shopStatus === null ||
					// 	this.jeet11PartnerDetails.shopStatus === "rejected";
				});
		},
		registerServiceWorker() {
			if ("serviceWorker" in navigator) {
				// eslint-disable-next-line no-undef
				window.addEventListener("load", () => {
					// eslint-disable-next-line no-undef
					navigator.serviceWorker
						.register("/service-worker.js", {
							updateViaCache: "none"
						})
						.then(() => {
							console.log("Service Worker registered!");
						})
						.catch(() => {
							console.warn("Service Worker registration failed!");
						});
				});
			}
		},
		sendTokenToServer(currentToken) {
			this.$store
				.dispatch(UPDATE_FIREBASE_TOKEN.dispatch, {
					token: currentToken
				})
				.catch(() => {});
		},
		signOut() {
			this.$store.dispatch(USER_LOG_OUT.dispatch);
			setTimeout(() => {
				window.location.reload();
			}, 500);
		},
		getNotificationPermissionFn() {
			if (supportsPushNotification()) {
				getNotificationPermission().then(result => {
					if (result === "granted") {
						navigator.serviceWorker.ready.then(reg => {
							FCMPush.loadFCMScript(
								reg,
								this.sendTokenToServer,
								true
							);
						});
					}
				});
			}
		},
		showNotifRedDot() {
			if (
				this.isJeet11Distributor &&
				this.dstrSignatureStatus === STATUS.REJECTED
			) {
				this.showNotifDot = true;
				this.notifDotPanelList = ["profile"];
			} else {
				this.showNotifDot = false;
				this.notifDotPanelList = [];
			}
		},
		getUserActiveAlerts() {
			this.$store
				.dispatch(GET_USER_ACTIVE_ALERTS.dispatch)
				.then(data => {
					this.retailAlert = data || [];
				})
				.catch(err => console.log(err));
		},
		changeAlertStatus(id) {
			this.$store
				.dispatch(CHANGE_ALERT_STATUS.dispatch, { alertId: id })
				.then(() => {
					// this.getUserActiveAlerts();
				})
				.catch(err => console.log(err));
		},
		goToProfile() {
			this.$router.replace("/profile");
			this.showAddLocationPopup = false;
		},
		handleAddLocationPopupClose() {
			this.showAddLocationPopup = false;
		}
	},
	watch: {
		ACCESS_TOKEN(newVal) {
			if (!newVal) {
				this.$router.replace("/");
				if (window.ReactNativeWebView) {
					window.ReactNativeWebView.postMessage(
						JSON.stringify({
							accessToken: ""
						})
					);
				}
			} else {
				if (window.ReactNativeWebView) {
					window.ReactNativeWebView.postMessage(
						JSON.stringify({
							accessToken: newVal
						})
					);
				}
				this.getNotificationPermissionFn();
			}
		},
		$route(to) {
			this.$store.dispatch(UPDATE_PAGE_TITLE.dispatch, {
				routeName: to.name
			});
		},
		dstrSignatureStatus() {
			this.showNotifRedDot();
		}
	}
};
</script>

<style lang="scss" scoped>
a.is-active,
a.is-active:hover,
.is-active > a,
.is-active > a:hover {
	background: #233b5d;
}
a {
	text-decoration: none;
}
.list__tile--link {
	display: block;
}
.background-transition {
	background: linear-gradient(to bottom, #2d4970, #233b5d);
}
.background--none {
	background: none;
}
.v-navigation-drawer .v-list {
	background: none;
}
.notif-dot {
	background-color: #e61818c4;
	width: 9px;
	height: 9px;
	border-radius: 100%;
	animation: blinker 0.8s cubic-bezier(0.895, 0.03, 0.685, 0.22) infinite
		alternate;
}
.menu-icon {
	position: fixed;
	top: 1.3em;
	left: 2.4em;
}
.panel-item {
	position: absolute;
	top: 0px;
	left: 0px;
}
.header-logo {
	max-width: 275px;
	height: 30px;
	margin-top: 5px;
	margin-left: -5px;
}
@keyframes blinker {
	from {
		opacity: 1;
	}
	to {
		opacity: 0.2;
	}
}
.menu-tile {
	display: flex;
	flex-direction: column;
	width: 200px;
}
</style>
